<div class="container-fluid">
    <div class="row mb-2">
        <div class="col-md-12">
            <div class="row align-items-center">
                <div class="col-md-1 text-center">
                    <i class="fa-solid fa-comments fa-2xl"></i>
                </div>
                <div class="col-md-11">
                    <h5>{{cintillo}}</h5>
                </div>
            </div>
        </div>
    </div>
    <div class="row mb-3">
        <div class="col-md-12">
            <!-- mospina 10-10-16 EPT-2380 Cambio general identidad AVATAR -->
            <div class="rounded" style="background-color: var(--app-claro, #53aaed); padding: 0.5em 0;">
                <div class="row align-items-center" style="color: white; text-align: center;">
                    <div class="col-md-2"><i class="fa fa-calendar-days fa-2x"></i></div>
                    <div class="col-md-8">
                        <h4 class="mb-0" style="color: white">{{tituloPantalla}}</h4>
                    </div>
                </div>
            </div>
            <div style="background-color: black; padding: 0.5em 0; color: white;">
                <div class="row align-items-center">
                    <div class="col-md-2 offset-md-8 offset-sm-0 col-sm-12" style="text-align: right">
                        <h5 class="mb-0" style="color: white; padding-right: 1em;">
                            <i class="fa-regular fa-calendar"></i> &nbsp; {{ahora | date: 'yyyy/MM/dd' }}
                        </h5>
                    </div>
                    <div class="col-md-2 col-sm-12" style="text-align: right">
                        <h5 class="mb-0" style="color: white; padding-right: 1em;">
                            <i class="fa-regular fa-clock"></i>&nbsp; {{ahora | date: 'hh:mm:ss a' }}
                        </h5>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div class="row" *ngIf="pantalla == 1">
        <div class="col-md-12">
            <div class="card">
                <div class="card-body">

                    <div class="row align-items-center">
                        <label for="" class="col-md-1">Sede:</label>
                        <div class="col-md-3">
                            <ng-select [items]="sedes" bindLabel="M05DES" [(ngModel)]="sedeSeleccionada">
                               
                            </ng-select>
                        </div>
                        <label for="" class="col-md-1">Período de matrícula activo:</label>
                        <div class="col-md-3">
                            <ng-select [items]="periodos" 
                            bindLabel="M19DES"
                            [(ngModel)]="periodoSeleccionado">   
                            </ng-select>
                        </div>
                        <label for="" class="col-md-1">Carrera:</label>
                        <div class="col-md-3">
                            <ng-select [items]="carreras" bindLabel="M02DES" bindValue="M04IUP" [(ngModel)]="M04IUP">
                                
                            </ng-select>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="col-md-12">
            <div class="card">
                <div class="card-body">
                    <h5 class="azul">Materías matriculadas</h5>
                    <hr class="azul">

                    <table class="table table-striped">
                        <thead>
                            <tr>
                                <td>Nombre del curso</td>
                                <td>Código</td>
                                <td>Créditos</td>
                                <td>Sede</td>
                                <td>Grupo</td>
                                <td>Profesor</td>
                                <td>Horario</td>
                                <td>Modo</td>
                                <td></td>
                            </tr>
                        </thead>
                        <tr>
                            <td>FUNDAMENTOS DE FÍSICA</td>
                            <td>GSST12</td>
                            <td>4.00</td>
                            <td>AVATARSYS 2023</td>
                            <td>2</td>
                            <td>DE ASIGNAR PROFESOR </td>
                            <td>M 1800-2100 L 1800-2100</td>
                            <td>Presencial Modificable</td>
                            <td>
                                <div ngbDropdown placement="bottom-left" style="cursor: pointer">
                                    <i class="mdi mdi-dots-vertical dropdown-toggle" ngbDropdownToggle
                                        data-toggle="dropdown" aria-expanded="true"></i>
                                    <div class="dropdown-menu dropdown-menu-end" ngbDropdownMenu>
                                        <a class="dropdown-item" title="Cambio de grupo" (click)="cambiarPantalla(2, 'CAMBIO DE GRUPO')">
                                            <i class=""></i>Cambio de grupo
                                        </a>
                                        <a class="dropdown-item" title="Notas">
                                            <i class=""></i>Notas
                                        </a>
                                        <a class="dropdown-item" title="Retirar materia">
                                            <i class=""></i>Retirar materia
                                        </a>
                                    </div>
                                </div>
                            </td>
                        </tr>
                        <ng-container *ngIf="matriculadas.length;else sinmatriculadas">
                           
                            <tr *ngFor="let matriculada of matriculadas">
                                <td>{{matriculada.materia.M11DES}}</td>
                                <td>{{matriculada.materia.M11COD}}</td>
                                <td>{{matriculada.materia.M11CRED}}</td>
                                <td></td>
                                <td>{{matriculada.grupo.M23GRU}}</td>
                                <td>{{matriculada.grupo.M26NOM}}</td>
                                <td style="white-space: pre-line">{{matriculada.grupo.HORARIO}}</td>
                                <td>{{matriculada.grupo.E05DES}}</td>
                                <td>
                                    <div ngbDropdown placement="bottom-left" style="cursor: pointer">
                                        <i class="mdi mdi-dots-vertical dropdown-toggle" ngbDropdownToggle
                                            data-toggle="dropdown" aria-expanded="true"></i>
                                        <div class="dropdown-menu dropdown-menu-end" ngbDropdownMenu>
                                            <a class="dropdown-item" title="Cambio de grupo" (click)="cambiarPantalla(2, 'CAMBIO DE GRUPO')">
                                                <i class=""></i>Cambio de grupo
                                            </a>
                                            <a class="dropdown-item" title="Notas">
                                                <i class=""></i>Notas
                                            </a>
                                            <a class="dropdown-item" title="Retirar materia">
                                                <i class=""></i>Retirar materia
                                            </a>
                                        </div>
                                    </div>
                                </td>
                            </tr>
                        </ng-container>
                        <ng-template #sinmatriculadas>
                            <tr>
                                <td colspan="9">Sin materías matriculadas</td>
                            </tr>
                        </ng-template>
                    </table>
                </div>
            </div>
        </div>
    </div>

    <div *ngIf="pantalla == 2">
        <div class="row">
            <div class="col-md-12">
                <div class="card">
                    <div class="card-body">
                        <h6 class="azul"><b>Curso matriculado actualmente que desea cambiar</b></h6>
                        <table class="table table-striped">
                            <thead>
                                <tr>
                                    <td>Nombre del curso</td>
                                    <td>Código</td>
                                    <td>Créditos</td>
                                    <td>Sede</td>
                                    <td>Grupo</td>
                                    <td>Profesor</td>
                                    <td>Horario</td>
                                    <td>Modo</td>
                                </tr>
                            </thead>
                            <tr>
                                <td>FUNDAMENTOS DE FÍSICA</td>
                                <td>GSST12</td>
                                <td>4.00</td>
                                <td>AVATARSYS 2023</td>
                                <td>2</td>
                                <td>DE ASIGNAR PROFESOR </td>
                                <td>M 1800-2100 L 1800-2100</td>
                                <td>Presencial Modificable</td>
                            </tr>
                        </table>
                    </div>
                </div>
            </div>
        </div>

        <div class="row" >
            <div class="col-md-12">
                <div class="card">
                    <div class="card-body">
                        <h6 class="azul"><b>Seleccione dentro las opciones de grupo para este curso:</b></h6>
                        <table class="table table-striped">
                            <thead>
                                <tr>
                                    <td>Nombre del curso</td>
                                    <td>Código</td>
                                    <td>Créditos</td>
                                    <td>Sede</td>
                                    <td>Grupo</td>
                                    <td>Profesor</td>
                                    <td>Horario</td>
                                    <td>Modo</td>
                                </tr>
                            </thead>
                            <tr>
                                <td>
                                    <div style="display: flex">
                                        <input type="radio" name="grupo">  
                                        <b class="azul" style="margin-left: 0.5em">FUNDAMENTOS DE FISICA</b>
                                    </div>
                                </td>                  
                                <td>GSST13</td>
                                <td>4.00</td>
                                <td>AVATARSYS 2023</td>
                                <td>2</td>
                                <td>DE ASIGNAR PROFESOR </td>
                                <td>M 1800-2100 L 1800-2100</td>
                                <td>Presencial Modificable</td>
                            </tr>
                            <tr>
                                <td>
                                    <div style="display: flex">
                                        <input type="radio" name="grupo">  
                                        <b class="azul" style="margin-left: 0.5em">FUNDAMENTOS DE FISICA</b>
                                    </div>
                                </td> 
                                <td>GSST14</td>
                                <td>4.00</td>
                                <td>AVATARSYS 2023</td>
                                <td>2</td>
                                <td>DE ASIGNAR PROFESOR </td>
                                <td>M 1800-2100 L 1800-2100</td>
                                <td>Presencial Modificable</td>
                            </tr>
                        </table>
                    </div>
                </div>
            </div>
        </div>

        <div class="row">
            <div class="col-md-2 offset-md-8">
                <button type="button" class="btn btn-secondary w-100" (click)="cambiarPantalla(1, 'PERIODO ACTUAL')">Cancelar</button>
            </div>
            <div class="col-md-2">
                <button type="button" class="btn btn-info w-100" (click)="confirmarCambioGrupo()">Continuar</button>
            </div>
        </div>
    </div> 
</div>

<ng-template #modalConfirmar let-modal>
    <!-- mospina 10-10-16 EPT-2380 Cambio general identidad AVATAR -->
    <div class="modal-header" style="border-bottom: 4px solid var(--app-oscuro, #0c7cb3)">
        <h4 class="modal-title azul" >Solicitud enviada</h4>
    </div>
    <div class="modal-body">
        <div class="row align-items-center">
            <div class="col-md-4">
                <img src="/assets/images/Icon_Alerta-Aprobado_Avatar-SyS.png" alt="" style="width: 100%">
            </div>
            <div class="col-md-8">
                <h5>La Solicitud srá enviada al departamento de registro. Se le comunicará a su correo la resolución en 5 días hábiles. Mientras
                    tanto por favor asista al grupo y horario que tiene matriculado actualmente
                </h5>

                <button type="button" class="btn btn-info mt-3 mb-3" style="float: right" (click)="modal.close()">Regresar a servicios estudiantiles</button>
            </div>
        </div>
    </div>
</ng-template>